import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from 'reactstrap';

export interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmColor?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info';
  cancelColor?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info';
  loading?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  onConfirm: () => void;
  onCancel: () => void;
  disableOnLoading?: boolean;
}

const ConfirmationModal = ({
  isOpen,
  title,
  message,
  confirmText = 'OK',
  cancelText = 'Cancel',
  confirmColor = 'primary',
  cancelColor = 'secondary',
  loading = false,
  size = 'md',
  onConfirm,
  onCancel,
  disableOnLoading = true,
}: ConfirmationModalProps) => {
  const handleConfirm = () => {
    if (!loading || !disableOnLoading) {
      onConfirm();
    }
  };

  const handleCancel = () => {
    if (!loading || !disableOnLoading) {
      onCancel();
    }
  };

  return (
    <Modal isOpen={isOpen} size={size}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        {typeof message === 'string' ? <div>{message}</div> : message}
      </ModalBody>
      <ModalFooter style={{ padding: '1em' }}>
        <Button
          color={cancelColor}
          onClick={handleCancel}
          disabled={loading && disableOnLoading}
        >
          {cancelText}
        </Button>
        {confirmText && (
          <Button
            color={confirmColor}
            onClick={handleConfirm}
            disabled={loading && disableOnLoading}
          >
            {confirmText}
            {loading && (
              <span style={{ paddingLeft: '1em' }}>
                <Spinner size="sm" />
              </span>
            )}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
